// @flow

import React from 'react'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import nigel1 from '../../images/team/nigel-1.jpg'
import nigel2 from '../../images/team/nigel-2.jpg'
import manfred1 from '../../images/team/manfred-1.jpg'
import manfred2 from '../../images/team/manfred-2.jpg'
import ranggi1 from '../../images/team/ranggi-1.jpg'
import ranggi2 from '../../images/team/ranggi-2.jpg'
import reny1 from '../../images/team/reny-1.jpg'
import reny2 from '../../images/team/reny-2.jpg'
import deni1 from '../../images/team/deni-1.jpg'
import deni2 from '../../images/team/deni-2.jpg'
import vinsen1 from '../../images/team/vinsen-1.jpg'
import vinsen2 from '../../images/team/vinsen-2.jpg'
import imgLinkedin from '../../images/linkedinIconColor.png'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import logoAstrnt from '../../images/public/logo-white.png'
import picNigel from '../../images/public/nigel-hembrow-pic.png'
import _axios from '../../dependencies/_axios'


type Props = {};

type State = {
	jobs: Array<Object>
};

class TeamPage extends React.Component<Props, State> {
  constructor() {
		super()

		this.state = {
			jobs: []
		}
	}

	componentDidMount() {

        _axios({
			url: `/astro-jobs`,
			timeout: 200000,
			method: 'get'
		})
		.then((response) => {
			this.setState({jobs: response.data})
		})
		.catch((error) => {
			console.error(error)
		})

		window.scrollTo(0, 0)
	}


  render() {
		const { jobs } = this.state

		let cols = ''
		let jobPost

		if (jobs.length) {
			if (jobs.length === 1) {
				cols = 'col-sm-12'
			} else if ( jobs.length === 2 ) {
				cols = 'col-sm-6'
			} else {
				cols = 'col-sm-4'
			}

			jobPost =	jobs
				.map((item, index) => (
					<div className={cols} key={index}>
            <div className="boxes-job">
              <div><h2 className="center bold m-b-16">{item.title}</h2></div>
              <div className="row">
                <div className={cols}>
									<video width="100%" height="auto" className="video-default" controls>
                    <source src={item.job_ads_video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
									<div className="flex-container">
		                <p className="heading4 m-t-16 center">We are always looking to add great team players, with strong technical skills, to our family. We really like people that have a passion for solving problems and that naturally see the "user perspective" in all we do. If you are interested in joining, please apply by clicking below, following the instructions and completing the video answers. See you on the other side!</p>
		                <div className="flex flex-center desc-job">
		                  <a
												href={`http://${item.job_url}`}
			                  className="button button__primary btn-sm m-t-24"
			                  name="button">See details</a>
		                </div>
		              </div>
                </div>
              </div>
            </div>
          </div>
				))
		}

    return (
			<main>
	      <section className="homepage-feature">
	        <Header isNavbarFixed={true} />
	        <div className="homepage-feature--image teampage">
	          <div className="container">
	            <div className="jumbotron">
	              <div className="row">
	                <div className="col-md-8 col-sm-12 col-xs-12">
										<div className="flex vertical-item--between">
	                    <div className="flex-1">
												<h2 className="m-t-0">Never finished & always seeking better, faster</h2>
			                  <p>Our mission at Astronaut is to make recruitment fast, fun & engaging for everyone, by transforming the way companies get to know candidates & the way candidates get to know about the places at which they hope to work. And we put video-selfies at the core of the experience. Why video? It’s for humans. Plus they’re rich in data.</p>
	                    </div>
	                  </div>
	                </div>
									<div className="col-md-4 mobile">
										<img src={logoAstrnt} className="img-responsive" alt="Astronaut Logo" />
									</div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
	      <section className="p-40">
	        <div className="container">
						<div className="row">
							<div className="col-md-9 col-md-push-3">
	              <div className="testimonial-item">
									<div className="testimonial-content">
										<i>“There are so many problems with recruitment that cause costs and damage to all involved. By designing new ways that are compatible with humanity’s latest communication behaviours, and leverage the latest communication technologies, we can make huge gains for our users.”</i>
										<p className="bold m-t-16">Nigel Hembrow, CEO Co-Founder, Astronaut</p>
									</div>
									<div className="testimonial-image">
										<img src={picNigel} className="m-l-16" alt="Nigel Hembrow" />
									</div>
	              </div>
	            </div>
							<div className="col-md-3 col-md-pull-9">
								<h2 className="section-heading">This is what we care about</h2>
							</div>
	          </div>
	          <div className="product-feature">
							<div className="media product-feature-list m-t-16">
								<div className="media-content--icon">
									<p className="heading4"><b>Here to help, always</b><br />Being available and present is a core part of building trust. And we seek to always be a trusted partner.</p>
								</div>
							</div>
							<div className="media product-feature-list">
								<div className="media-content--icon">
									<p className="heading4"><b>We’re never finished</b><br />Technology doesn’t ever stop, instead it gives us constant tools, ideas and inspiration to continually innovate and co-create. We can always be better.</p>
								</div>
							</div>
							<div className="media product-feature-list">
								<div className="media-content--icon">
									<p className="heading4"><b>Power of negative thinking</b><br />Famous astronaut, Chris Hadfield, uses this phrase to frame his approach to preparation and risk management. We agree.</p>
								</div>
							</div>
							<div className="media product-feature-list">
								<div className="media-content--icon">
									<p className="heading4"><b>Personal improvement goals</b><br />Know what you want, and you’ll find it’s easier for others to help you get it. Our goal is to support everyone to get better everyday.</p>
								</div>
							</div>
							<div className="media product-feature-list">
								<div className="media-content--icon">
									<p className="heading4"><b>Partner well</b><br />In an interconnected world of platforms, APIs, resellers and global teams it’s critical to uphold a reputation of being a great partner.</p>
								</div>
							</div>
							<div className="media product-feature-list">
								<div className="media-content--icon">
									<p className="heading4"><b>Be local, reach global</b><br />Platforms are global, but our users lives and problems are local. We need to respect both with strong clarity.</p>
								</div>
							</div>
	          </div>
					</div>
	      </section>
	      <section className="p-t-76">
	        <div className="container-team">
	          <h2 className="section-heading center">Meet our team</h2>
	          <div className="gallery-card">
	            <div className="gallery-card-item">
	              <div className="gallery-card-image">
	                <img src={nigel2} alt="" className="avatar" />
	                <img src={nigel1} alt="" className="avatar top" />
	              </div>
	              <div className="gallery-card-name">
	                <div className="heading5">
	                  Nigel Hembrow
	                </div>
	                <div className="paragraph m-b-16">CEO, Co-Founder</div>
	                <div className="paragraph">#dedication <br />#focus #dadbodevolution</div>
	                <a href="https://sg.linkedin.com/in/nigelhembrow" target="_blank" rel="noopener noreferrer">
	                  <img src={imgLinkedin} alt="" className="m-t-8"/>
	                </a>
	              </div>
	            </div>
	            <div className="gallery-card-item">
	              <div className="gallery-card-image">
	                <img src={manfred2} alt="" className="avatar" />
	                <img src={manfred1} alt="" className="avatar top" />
	              </div>
	              <div className="gallery-card-name">
	                <div className="heading5">
	                  Manfred Ekblad
	                </div>
	                <div className="paragraph m-b-16">CTO, Co-Founder</div>
	                <div className="paragraph">#getstuffdone <br />#stepbystep #automateeverything</div>
	                <a href="https://www.linkedin.com/in/manfredekblad" target="_blank" rel="noopener noreferrer">
	                  <img src={imgLinkedin} alt="" className="m-t-8" />
	                </a>
	              </div>
	            </div>
	            <div className="gallery-card-item">
	              <div className="gallery-card-image">
	                <img src={ranggi2} alt="" className="avatar" />
	                <img src={ranggi1} alt="" className="avatar top" />
	              </div>
	              <div className="gallery-card-name">
	                <div className="heading5">
	                  Ranggi Primon
	                </div>
	                <div className="paragraph m-b-16">Operation & Partnership Manager</div>
	                <div className="paragraph">#mamaAstronaut #hustleharder #happinessassurance</div>
	                <a href="https://www.linkedin.com/in/manfredekblad" target="_blank" rel="noopener noreferrer">
	                  <img src={imgLinkedin} alt="" className="m-t-8" />
	                </a>
	              </div>
	            </div>
	            <div className="gallery-card-item">
	              <div className="gallery-card-image">
	                <img src={reny2} alt="" className="avatar" />
	                <img src={reny1} alt="" className="avatar top" />
	              </div>
	              <div className="gallery-card-name">
	                <div className="heading5">
	                  Reny Mustika
	                </div>
	                <div className="paragraph m-b-16">Senior iOS Developer</div>
	                <div className="paragraph">#coder <br />#thinker #fighter</div>
	                <a href="https://www.linkedin.com/in/reny-mustika-3852b111b/" target="_blank" rel="noopener noreferrer">
	                  <img src={imgLinkedin} alt="" className="m-t-8" />
	                </a>
	              </div>
	            </div>
	            <div className="gallery-card-item">
	              <div className="gallery-card-image">
	                <img src={vinsen2} alt="" className="avatar" />
	                <img src={vinsen1} alt="" className="avatar top" />
	              </div>
	              <div className="gallery-card-name">
	                <div className="heading5">
	                  Vinsensius Kevin
	                </div>
	                <div className="paragraph m-b-16">Web Developer</div>
	                <div className="paragraph">#workinprogress #tillicollapse #nevergiveuptobehappy</div>
	                <a href="https://www.linkedin.com/in/vinsensius-kevin/" target="_blank" rel="noopener noreferrer">
	                  <img src={imgLinkedin} alt="" className="m-t-8" />
	                </a>
	              </div>
	            </div>
	            <div className="gallery-card-item">
	              <div className="gallery-card-image">
	                <img src={deni2} alt="" className="avatar" />
	                <img src={deni1} alt="" className="avatar top" />
	              </div>
	              <div className="gallery-card-name">
	                <div className="heading5">
	                  Deni Rohimat
	                </div>
	                <div className="paragraph m-b-16">Android Software Engineer</div>
	                <div className="paragraph">#bugFix <br />#refactor #clearBug</div>
	                <a href="https://www.linkedin.com/in/derohimat/" target="_blank" rel="noopener noreferrer">
	                  <img src={imgLinkedin} alt="" className="m-t-8" />
	                </a>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
	      <section className="m-t-76">
	        <div className="container">
	          <h3 className="section-heading m-b-16 center">Opportunities to join us</h3>
						<p className="heading3 normal center m-b-40">We are always looking to add great team players to our family. If you feel the above values match your expectations and ambitions, please contact us.</p>
	          <div className="row">
	            <div className="col-sm-12 col-xs-12">
	              <div className="video-box">
	                {jobPost}
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<div className="section-divider"></div>
						</div>
					</div>
				</div>
	      <SupportList />
				<CallToActRegister />
				<Footer />
			</main>
		)
  }
}

export default TeamPage
